import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { routerReducer, RouterState } from '@ngrx/router-store';
import { environment } from '@config/environment';
import * as fromLocalLoginIds from './local-login-ids/local-login-ids.reducer';

export interface AppState {
  router: RouterState;
  [fromLocalLoginIds.localLoginIdsFeatureKey]: fromLocalLoginIds.LocalLoginId[];
}

export const reducers: ActionReducerMap<AppState> = {
  router: routerReducer,
  [fromLocalLoginIds.localLoginIdsFeatureKey]: fromLocalLoginIds.reducer,
};

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? [logger]
  : [];
